import { categories } from '@/mocks/categories';

export default function Hero() {
  const handleDropdownChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const url = e.target.value;
    if (url) {
      window.open(url, '_blank', 'noopener,nofollow');
    }
  };

  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Elegant%20product%20photography%20flat%20lay%20composition%20on%20warm%20cream%20linen%20surface%20with%20carefully%20arranged%20sneakers%20folded%20knitwear%20leather%20accessories%20and%20dried%20botanical%20elements%2C%20soft%20diffused%20natural%20window%20light%20from%20left%20side%20creating%20gentle%20shadows%2C%20minimalist%20editorial%20fashion%20aesthetic%2C%20harmonious%20sage%20green%20terracotta%20and%20sand%20tones%2C%20calm%20sophisticated%20mood&width=1920&height=1080&seq=hero-bg-v3&orientation=landscape')`,
        }}
      >
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 py-32 md:py-40 text-center">
        <div className="animate-[fadeInUp_0.8s_ease-out]">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
            Kakobuy Spreadsheet Polska – Najlepsza Lista Produktów i Znalezisk 2026
          </h1>
          <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-10 leading-relaxed">
            Odkrywaj najlepsze produkty z Chin szybciej dzięki Kakobuy Spreadsheet. Znajdź sneakersy, ubrania, akcesoria i popularne produkty w jednym miejscu.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto bg-primary-500 hover:bg-primary-600 text-white font-semibold text-base px-8 py-3.5 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/25"
            >
              Kakobuy Spreadsheet
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto bg-white/90 hover:bg-white text-foreground-900 font-semibold text-base px-8 py-3.5 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer backdrop-blur-sm"
            >
              Buy It Now
            </a>
          </div>

          <div className="max-w-md mx-auto mb-12">
            <label htmlFor="category-select" className="block text-sm text-white/70 mb-2 text-left">
              Wybierz kategorię produktów:
            </label>
            <div className="relative">
              <select
                id="category-select"
                onChange={handleDropdownChange}
                defaultValue=""
                className="w-full appearance-none bg-white/95 backdrop-blur-sm text-foreground-900 text-sm rounded-full px-5 py-3.5 pr-12 cursor-pointer border-0 outline-none focus:ring-2 focus:ring-primary-400 transition-all duration-200"
              >
                <option value="" disabled>— Wybierz kategorię —</option>
                {categories.map((cat) => (
                  <option key={cat.name} value={cat.url}>
                    {cat.name}
                  </option>
                ))}
              </select>
              <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-drop-down-line text-xl text-foreground-500"></i>
              </div>
            </div>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6">
            {[
              { icon: 'ri-checkbox-circle-line', text: 'Aktualizowane listy produktów' },
              { icon: 'ri-guide-line', text: 'Przewodnik dla użytkowników Polska' },
              { icon: 'ri-scales-3-line', text: 'Porównania produktów' },
              { icon: 'ri-shield-check-line', text: 'Bezpieczne zakupy' },
            ].map((badge) => (
              <div
                key={badge.text}
                className="flex items-center gap-2 text-white/90 text-xs md:text-sm whitespace-nowrap"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className={`${badge.icon} text-accent-400 text-sm`}></i>
                </div>
                {badge.text}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}